<template>
  <div class="search-history-component">
    <ym-search-block title="搜索历史"
    >
      <div v-if="emptyHistory"
           class="empty-search-text"
      >无搜索历史
      </div>
      <div v-else
           class="history-container"
      >
        <div v-for="(key, index) in list"
             :key="index"
        >
          <ym-button class="history-btn"
                     type="text"
                     size="extra-small"
                     @click="handleClickHistoryItem(key)"
          >
            {{ key }}
          </ym-button>
        </div>
      </div>
    </ym-search-block>
    <ym-button v-if="!emptyHistory"
               class="clear-history-btn"
               type="text"
               @click="handleClearHistory"
    >
      清空搜索历史
    </ym-button>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import SearchBlock from '@/components/Search/Block';
  import { SEARCH_HISTORY_MAX } from '@/utils/constant';
  import { setSearchHistory, getSearchHistory } from '@/utils';

  export default {
    name: 'History',
    components: {
      'ym-search-block': SearchBlock,
      'ym-button': Button,
    },
    data() {
      return {
        list: [],
      };
    },
    props: {
      history: {
        type: String,
        default: '',
      },
    },
    computed: {
      emptyHistory() {
        return this.list.length === 0;
      },
    },
    watch: {
      history(val) {
        this.updateHistory(val);
      },
    },
    methods: {
      handleClickHistoryItem(key) {
        this.$emit('click', key);
        this.updateHistory(key);
      },
      updateStorage() {
        setSearchHistory(this.list);
      },
      handleClearHistory() {
        this.list = [];
        this.updateStorage();
      },
      updateHistory(item) {
        const { list } = this;
        const { length } = list;
        const existIndex = list.findIndex(i => i === item);
        if (existIndex > -1) {
          // 已存在历史记录中，则移动最前
          list.splice(existIndex, 1);
        }
        if (length >= SEARCH_HISTORY_MAX) {
          const lastIndex = length - 1;
          list.splice(lastIndex, 1);
        }
        list.unshift(item);
        this.updateStorage();
      },
    },
    created() {
      this.list = getSearchHistory();
      const { history } = this;
      if (history && history !== '') {
        this.updateHistory(history);
      }
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @history-btn-padding: 6px;
  .empty-search-text {
    color: @color-text-lighter;
    font-size: @font-size-base;
  }

  .history-container {
    margin-top: -@size-extra-small - @history-btn-padding;
    margin-bottom: -@history-btn-padding;
  }

  .history-btn {
    padding: 0;
    color: @color-text-light;
    margin-top: @size-extra-small;
  }

  .clear-history-btn {
    display: block;
    margin: @size-small auto 0;
    color: @color-text-primary;
  }
</style>
